/* eslint-env jest */
import { getCanvasDimensions, getExportRatio } from './canvasUtils';

describe('getCanvasDimensions + getExportRatio round-trip', () => {
  it('exports at native resolution when no scaling_factor is set (legacy/use_new_scaling: false templates)', () => {
    // Every template created via NewTemplatesController#create has
    // use_new_scaling forced to false, so scaling_factor is always nil for
    // these -- the on-screen canvas is shown at full native resolution
    // (factor defaults to 1), so the export ratio must also default to 1
    // to avoid re-multiplying an already-native-resolution canvas.
    const dimensions = getCanvasDimensions(null, 3300, 5100);
    expect(dimensions).toEqual({ width: 3300, height: 5100 });

    const ratio = getExportRatio(undefined, null);
    expect(ratio).toBe(1);
    expect(dimensions.width * ratio).toBe(3300);
    expect(dimensions.height * ratio).toBe(5100);
  });

  it('reconstructs native resolution when scaling_factor shrinks the editing canvas (use_new_scaling: true)', () => {
    const dimensions = getCanvasDimensions(3, 3300, 5100);
    expect(dimensions).toEqual({ width: 1100, height: 1700 });

    const ratio = getExportRatio(undefined, 3);
    expect(ratio).toBe(3);
    expect(dimensions.width * ratio).toBe(3300);
    expect(dimensions.height * ratio).toBe(5100);
  });

  it('an explicit pixelRatio argument overrides the scaling_factor fallback', () => {
    expect(getExportRatio(2, 3)).toBe(2);
    expect(getExportRatio(2, null)).toBe(2);
  });
});
